import React, { Component } from "react";
import Route from "./Routes/routeIndex";
import "./App.css";

//import style
import "./assets/css/pe-icon-7.css";
import "./assets/css/materialdesignicons.min.css";
import "./assets/scss/theme.scss";
import process from "process";
import Access from "./pages/Access";

// import Protect from 'react-app-protect'
 

class App extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      isVerified: false
    };
    
  }
  componentDidMount() {
  
  }
  checkPw = (answer) => {
    //  const answer = document.getElementById("password").value;
    
    if (answer === process.env.REACT_APP_MY_ENVIRONMENT_VARIABLE ) {
      this.setState({ isVerified: true });
    } else {
      alert("WRONG ! Access Key");
    }
  };

  render() {
    const { isVerified } = this.state;
    return (
      <>
      {isVerified ?  <React.Fragment>
        <Route />
      </React.Fragment>
       :
       (
        <Access callback={this.checkPw}/>
        // <form onSubmit={this.checkPw}>
        //  <input id="password" name="password" />
        //  <button>open sesame</button>
        // </form>
      )
    }
      </>
      
    );
  }
}

export default App;
